// src/components/commercial/CommercialSmartWidget.js
import React, { useEffect, useState } from 'react';
import pb from '../../lib/pocketbase';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function CommercialSmartWidget() {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [suggestions, setSuggestions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function fetchSmartData() {
            try {
                // 1. Fetch Deals in 'proposition' stage updated more than 3 days ago
                const oldProposals = await pb.collection('deals').getFullList({
                    filter: `owner = "${user.id}" && stage = "proposal" && updated < "${new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString()}"`
                });

                // 2. Fetch New Leads (created < 2 days) with no notes (implying no contact)
                // Note: filtering by "notes" empty is hard in PB directly sometimes, we'll filter client side for MVP
                const newLeads = await pb.collection('customers').getFullList({
                    filter: `(created_by = "${user.id}" || commercial_id = "${user.id}") && created > "${new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString()}"`
                });

                const smartActions = [];

                oldProposals.forEach(d => {
                    smartActions.push({
                        id: `prop-${d.id}`,
                        type: 'followup_proposal',
                        title: 'Relance Proposition',
                        desc: `Devis "${d.title}" sans réponse depuis 3j+`,
                        priority: 'high',
                        action: () => navigate('/commercial/phoning') // Or directly to deal
                    });
                });

                newLeads.forEach(l => {
                    if (!l.notes || l.notes.length < 10) { // Simple check
                        smartActions.push({
                            id: `lead-${l.id}`,
                            type: 'new_lead',
                            title: 'Nouveau Lead à qualifier',
                            desc: `${l.name} vient d'arriver. Appelez-le !`,
                            priority: 'medium',
                            action: () => navigate('/commercial/phoning')
                        });
                    }
                });

                setSuggestions(smartActions.slice(0, 3)); // Top 3
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }
        fetchSmartData();
    }, [user.id, navigate]);

    if (loading) return null;
    if (suggestions.length === 0) return null; // Don't show if nothing to do

    return (
        <div className="card" style={{ padding: '20px', background: 'linear-gradient(135deg, #eff6ff, #fff)', border: '1px solid #bfdbfe', borderRadius: 12, marginBottom: 24 }}>
            <h3 style={{ marginTop: 0, marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8, color: '#1e3a8a' }}>
                <span>🧠</span> Suggestions IA
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {suggestions.map(s => (
                    <div key={s.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'white', padding: 12, borderRadius: 8, border: '1px solid #dbeafe' }}>
                        <div>
                            <div style={{ fontWeight: 600, color: '#1e40af', fontSize: '0.95rem' }}>{s.title}</div>
                            <div style={{ fontSize: '0.85rem', color: '#64748b' }}>{s.desc}</div>
                        </div>
                        <button onClick={s.action} style={{ background: '#3b82f6', color: 'white', border: 'none', borderRadius: 6, padding: '6px 12px', fontSize: '0.8rem', cursor: 'pointer' }}>
                            Agir
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
